import { ComponentConfig } from "@measured/puck";
import { Box } from "@mui/material";

import { Separator as SeparatorComponent, SeparatorProps } from "./Separator";
import ColorPickerField from "src/components/Puck/config/fields/ColorPickerField";

export type { SeparatorProps } from "./Separator";

export const Separator: ComponentConfig<SeparatorProps> = {
    label: "Separator",
    fields: {
        thickness: {
            type: "select",
            label: "Thickness",
            options: [
                { label: "Thin", value: 1 },
                { label: "Medium", value: 2 },
                { label: "Thick", value: 3 },
                { label: "Extra Thick", value: 4 },
            ],
        },
        color: {
            type: "custom",
            label: "Color",
            render: (props) => <ColorPickerField {...props} />,
        },
        variant: {
            type: "select",
            label: "Variant",
            options: [
                { label: "Full Width", value: "fullWidth" },
                { label: "Inset", value: "inset" },
                { label: "Middle", value: "middle" },
            ],
        },
        orientation: {
            type: "select",
            label: "Orientation",
            options: [
                { label: "Horizontal", value: "horizontal" },
                { label: "Vertical", value: "vertical" },
            ],
        },
        marginY: {
            type: "select",
            label: "Margin",
            options: [
                { label: "None", value: 0 },
                { label: "Small", value: 1 },
                { label: "Medium", value: 2 },
                { label: "Large", value: 3 },
                { label: "Extra Large", value: 4 },
            ],
        },
    },
    defaultProps: {
        thickness: 1,
        variant: "fullWidth",
        orientation: "horizontal",
        marginY: 2,
    },
    render: (props) => {
        const separatorProps = {
            ...props,
        };

        return (
            <Box>
                <SeparatorComponent {...separatorProps} />
            </Box>
        );
    },
};
